import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class MoveService {
  private apiUrl = '/moves';
  private apiSpringUrl = '/spring/moves'

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}?ownerId=${ownerId}`;
    return this.http.get(url);
  }

  save(json?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/save';

    return this.http.post(url, json);
  }

  printpdf(json?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/printpdf';

    return this.http.post(url, json);
  }

  complete(json?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/complete';

    return this.http.post(url, json);
  }

  cancel(json?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl + '/cancel';

    return this.http.post(url, json);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/move/move.service.ts